import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';

// Field definition from the API's `definitions`, shown on hover or focus.
function InfoTip({ text }) {
  if (!text) return null;
  return (
    <Tooltip title={text} arrow placement="top">
      <button
        type="button"
        aria-label={text}
        className="inline-flex align-middle text-gray-400 hover:text-gray-600 focus:outline-none focus-visible:text-claret-500"
      >
        <InfoOutlinedIcon sx={{ fontSize: 14 }} />
      </button>
    </Tooltip>
  );
}

export default InfoTip;
